import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CommonService } from '../../services/common.service';
import { Path, Config } from '../../enums';
import { AuthenticationService } from '../../modules/authentication/services/authentication.service';
import { UtilsService } from '../../services/utils.service';
import { EnvService } from '../../services/env.service';
@Injectable({
    providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
    error!: string;
    statusCodes: any;
    errorMsgConfig: any = {};

    constructor(
        private cmnSrv: CommonService,
        private utilSrv : UtilsService,
        private authSrv: AuthenticationService,
        private envService: EnvService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(tap({
            next: () => {
                // do anything with the response if necessary
            },
            error: async (error) => {
                if (error instanceof HttpErrorResponse) {

                    this.errorMsgConfig = await this.cmnSrv.loadConfig({
                        path: Path.ERROR_MESSAGE_CONFIG_PATH,
                        configType: Config.ERROR_MESSAGE_CONFIG
                    })
                    let ourDomain = '';
                    if (error.status === 401 && error?.url?.includes(this.envService.baseUrl) && error?.url !== this.envService.proxyApiUrl) {
                        this.utilSrv.logout();
                        return
                    } else {
                        const errorMessage = this.setError(error);
                        return throwError(() => errorMessage);
                    }
                }else {
                    return
                }
            }
        }));
    }

    setError(err: HttpErrorResponse): string | Observable<any> {
        let errorMessage = this.errorMsgConfig['DefaultErrorMessage']['message'];

        if (err.error instanceof ErrorEvent) {
            //client side error
            errorMessage = err.message
        } else {
            //server side error
            const loggedIn = this.authSrv.isLoggedIn();
            errorMessage = err.error.message ? err.error.message : this.errorMsgConfig?.[err.status]?.['message'];

            if (err.status === 401) {
                return errorMessage;
            }

            if (err.status === 400 && loggedIn) {
                errorMessage = err.error.message ? { message: err.error.message, code: err.error.statusCode }: this.errorMsgConfig?.[err.status]?.['message'];
            }

        }
        return errorMessage;
    }
}
